import { asyncActionCreator } from '../../shared/redux/actions/common'
import { ADMIN_PROFILE_LOGO_DELETE, FETCH_MARKETS, FETCH_REPORTS, FETCH_TENANTS } from '../const'
import { sendJson, patchProperty, getJson } from '../../shared/utils/api'
import { config } from '../../config'
import { TenantModel } from '../../shared/types/tenant';

interface PasswordInfo {
    currentPassword: string;
    newPassword: string;
}

export const updateAdmin = (tenantUserId: string, admin: TenantModel) => {
    return sendJson(`tenant/${tenantUserId}`, 'PATCH', [
        patchProperty('contact', admin.contact),
    ])
}

// need to be id of image
export const deleteLogo = (id: string) => {
    return asyncActionCreator(ADMIN_PROFILE_LOGO_DELETE, () => sendJson(`image/${id}`, 'DELETE'))
}

export const updatePassword = (passwordInfo: PasswordInfo) => {
    return sendJson(`tenant/password`, 'POST', passwordInfo)
}

export const fetchTenants = () => {
    return asyncActionCreator(FETCH_TENANTS, () => getJson('tenant/all'))
}

export const fetchMarkets = () => {
    return asyncActionCreator(FETCH_MARKETS, () => getJson(`market/all`))
}

export const fetchReports = (tenantId: string) => {
    if (tenantId === config.mainTenantId) {
        return asyncActionCreator(FETCH_REPORTS, () => getJson(`report/all`))
    } else {
        return asyncActionCreator(FETCH_REPORTS, () => getJson(`report/${tenantId}`))
    }
}